// src/components/FileUpload.js
import React from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx'; // --- NEW: Import the xlsx library ---
import { Upload } from 'react-feather'; // Using a more generic icon

function FileUpload({ onFileParsed }) {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    // --- NEW: Logic to handle different file types ---
    if (file.name.endsWith('.csv')) {
      // Use PapaParse for CSV files (existing logic)
      reader.onload = (e) => {
        Papa.parse(e.target.result, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            onFileParsed({ headers: results.meta.fields, data: results.data });
          },
          error: (error) => console.error("CSV Parsing Error:", error),
        });
      };
      reader.readAsText(file);

    } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
      // Use SheetJS (xlsx) for Excel files
      reader.onload = (e) => {
        try {
          const workbook = XLSX.read(e.target.result, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 0, defval: "" });
          const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] || [];
          
          // Pass the data in the same format as PapaParse
          onFileParsed({ headers, data: jsonData });
        } catch (error) {
          console.error("Excel Parsing Error:", error);
          alert("There was an error parsing the Excel file.");
        }
      };
      reader.readAsBinaryString(file); // Use this for Excel files
    } else {
      alert("Unsupported file type. Please upload a CSV or Excel file.");
    }

    event.target.value = null; // Reset the input
  };

  return (
    <div>
      <label htmlFor="file-upload-input" className="file-upload-button" title="Upload CSV or Excel File">
        <Upload size={16} />
      </label>
      <input
        id="file-upload-input"
        type="file"
        // --- NEW: Accept Excel file extensions ---
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
}

export default FileUpload;
